import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { CustomDialog } from "../../ui";
import EditProfileDialog from "./EditProfileDialog";
import EditIntroductionDialog from "./EditIntroductionDialog";
import EditHeroDialog from "./EditHeroDialog";
import EditEducationDialog from "./EditEducationDialog";
import EditHobbies from "./EditHobbies";
import EditGoals from "./EditGoals";
import EditAdmiredCompanies from "./EditAdmiredCompanies";
import EditExperienceDialog from "./EditExperienceDialog";
import EditIndustryDialog from "./EditIndustryDialog";
import EditTopSkillsDialog from "./EditTopSkillsDialog";
import EditFeaturedLinksDialog from "./EditFeaturedLinksDialog";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import EditPastExperiences from "./EditPastExperiences";

type EditPropsType = {
  from: string;
  name?: string;
  headline?: string;
  currentCompany?: string;
  city?: string;
  image?: string;
  introduction?: string;
  hero?: string;
  underGrad?: string;
  postGrad?: string;
  hobbies?: string[];
  goals?: string[];
  admiredCompanies?: string[];
  experience?: string;
  tagsAndIndustry?: string[];
  topSkills?: string[];
  featuredLinks?: string[];
  pastExperience?: any[];
  eachPastExperience?: any;
};

function EditDialog({
  from,
  name,
  headline,
  currentCompany,
  city,
  image,
  introduction,
  hero,
  underGrad,
  postGrad,
  hobbies,
  goals,
  admiredCompanies,
  experience,
  tagsAndIndustry,
  topSkills,
  featuredLinks,
  pastExperience,
  eachPastExperience,
}: EditPropsType) {
  const [open, setOpen] = useState(false);

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const DialogToDisplay = () => {
    switch (from) {
      case "general":
        return (
          <EditProfileDialog
            name={name}
            headline={headline}
            workplace={currentCompany}
            city={city}
            image={image}
            onClose={onClose}
          />
        );
      case "introduction":
        return (
          <EditIntroductionDialog
            onClose={onClose}
            introduction={introduction!}
          />
        );
      case "hero":
        return <EditHeroDialog onClose={onClose} hero={hero} />;

      case "education":
        return (
          <EditEducationDialog
            underGrad={underGrad}
            postGrad={postGrad}
            onClose={onClose}
          />
        );
      case "hobbies":
        return <EditHobbies hobbies={hobbies} onClose={onClose} />;
      case "goals":
        return <EditGoals goals={goals} onClose={onClose} />;
      case "admiredCompanies":
        return (
          <EditAdmiredCompanies
            admiredCompanies={admiredCompanies}
            onClose={onClose}
          />
        );
      case "experience":
        return (
          <EditExperienceDialog
            yearsOfExperience={experience}
            onClose={onClose}
          />
        );
      case "tagsAndIndustry":
        return (
          <EditIndustryDialog
            tagsAndIndustry={tagsAndIndustry}
            onClose={onClose}
          />
        );
      case "topSkills":
        return <EditTopSkillsDialog topSkills={topSkills} onClose={onClose} />;
      case "featuredLinks":
        return (
          <EditFeaturedLinksDialog
            featuredLinks={featuredLinks!}
            onClose={onClose}
          />
        );
      case "pastExperience":
        return (
          <EditPastExperiences
            pastExperience={pastExperience}
            onClose={onClose}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
          zIndex: 3,
        }}
      >
        <IconButton onClick={onOpen} size="small">
          {from === "pastExperience" ? (
            <AddCircleOutlineOutlinedIcon />
          ) : (
            <EditOutlinedIcon />
          )}
        </IconButton>
      </Box>
      <CustomDialog open={open} onClose={onClose} fullWidth>
        <DialogToDisplay />
      </CustomDialog>
    </>
  );
}

export default EditDialog;
